import React from 'react'
import { ButtonRounded, SectionTitle } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24ChevronDown24, IconS24ChevronUp24 } from '@is24/cosma-ui-icons'
import { RentPriceCheckDetails } from './rent-price-check-details/RentPriceCheckDetails'
import { RentPriceCheckLabel } from './rent-price-check-label/RentPriceCheckLabel'
import { PriceBenchmark } from './price-benchmark/PriceBenchmark'
import styles from './RentPriceCheck.module.css'

type RentPriceCheckProps = {
  minValue: number
  maxValue: number
  recommendedValue: number
  price?: number
  livingSpace?: string
  isExpanded: boolean
  onExpandedChange: (isExpanded: boolean) => void
}

export function RentPriceCheck({
  minValue,
  maxValue,
  recommendedValue,
  price,
  livingSpace,
  isExpanded,
  onExpandedChange,
}: RentPriceCheckProps) {
  const { t } = useTranslation()

  return (
    <section
      className={styles.card}
      aria-label={t('wizard.screen.basicInfo.price.recommendedNotification.check.label')}
    >
      <div className={styles.title}>
        <RentPriceCheckLabel />
        <SectionTitle
          title={t('wizard.screen.basicInfo.price.recommendedNotification.check.title')}
          size='extraSmall'
          variant='bold'
          description={t('wizard.screen.basicInfo.price.recommendedNotification.check.description')}
        />
      </div>

      <PriceBenchmark minValue={minValue} maxValue={maxValue} recommendedValue={recommendedValue} price={price} />

      <div className={styles.details}>
        {isExpanded && (
          <RentPriceCheckDetails minValue={minValue} maxValue={maxValue} price={price} livingSpace={livingSpace} />
        )}
        <ButtonRounded
          size='small'
          width='content'
          variant='textDefault'
          endElement={isExpanded ? <IconS24ChevronUp24 /> : <IconS24ChevronDown24 />}
          onClick={() => onExpandedChange(!isExpanded)}
        >
          {t(
            isExpanded
              ? 'wizard.screen.basicInfo.price.recommendedNotification.check.showLessDetails'
              : 'wizard.screen.basicInfo.price.recommendedNotification.check.showMoreDetails'
          )}
        </ButtonRounded>
      </div>
    </section>
  )
}
